export default {
  phone_number: '+33695429513', // numéro de dan
};
